"use client";

import { useEffect, useState, type ComponentPropsWithoutRef } from "react";
import Image from "next/image";
import { useTheme } from "next-themes";
import { cn } from "@/lib/utils";

type EmptyStageIllustrationProps = Omit<
  ComponentPropsWithoutRef<typeof Image>,
  "src" | "alt"
> & {
  alt?: string;
};

function useEmptyStageIllustrationSrc() {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return "/assets/pipeline/empty-stage.svg";
  }

  return resolvedTheme === "light"
    ? "/assets/light/pipeline-empty-stage.svg"
    : "/assets/pipeline/empty-stage.svg";
}

export function EmptyStageIllustration({
  className,
  alt = "",
  width = 215,
  height = 140,
  ...props
}: EmptyStageIllustrationProps) {
  const src = useEmptyStageIllustrationSrc();

  return (
    <Image
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={cn("h-[140px] w-[215px]", className)}
      {...props}
    />
  );
}
